module.exports = __webpack_public_path__ + "static/media/Ivo.d002b0fd.jpg";